import { createRouter, createWebHistory } from 'vue-router'
import { useSessionStore } from '@/stores/session'

import Login from '@/views/Login.vue'
import Register from '@/views/Register.vue'
import ForgotPassword from '@/views/ForgotPassword.vue'
import Explore from '@/views/Explore.vue'
import CreateFlyer from '@/views/CreateFlyer.vue'
import UpdateFlyer from '@/views/UpdateFlyer.vue'
import CreatedList from '@/views/CreatedList.vue'
import SavedFlyers from '@/views/SavedFlyers.vue'
import MyAccount from '@/views/MyAccount.vue'
import UpdateProfile from '@/views/UpdateProfile.vue'
import UserProfile from '@/views/UserProfile.vue'
import FlyerDetail from '@/views/FlyerDetail.vue'
import FlyerInfo from '@/views/FlyerInfo.vue'
import HashtagFlyers from '@/views/HashtagFlyers.vue'
import BusinessReviews from '@/views/BusinessReviews.vue'
import ChangePassword from '@/views/ChangePassword.vue'
import Boards from '@/views/Boards.vue'
import Chats from '@/views/Chats.vue'
import About from '@/views/About.vue'
import PrivacyPolicy from '@/views/PrivacyPolicy.vue'
import TermsConditions from '@/views/TermsConditions.vue'
import Faqs from '@/views/Faqs.vue'
import Support from '@/views/Support.vue'
import Settings from '@/views/Settings.vue'
import TimezoneSettings from '@/views/TimezoneSettings.vue'

const routes = [
  { path: '/', redirect: '/explore' },
  { path: '/login', name: 'login', component: Login, meta: { guestOnly: true } },
  { path: '/register', name: 'register', component: Register, meta: { guestOnly: true } },
  { path: '/forgot-password', name: 'forgot-password', component: ForgotPassword, meta: { guestOnly: true } },
  { path: '/explore', name: 'explore', component: Explore, meta: { public: true } },
  { path: '/flyers/create', name: 'create-flyer', component: CreateFlyer, meta: { requiresAuth: true } },
  { path: '/flyers/:id/edit', name: 'update-flyer', component: UpdateFlyer, meta: { requiresAuth: true } },
  { path: '/flyers/created', name: 'created-list', component: CreatedList, meta: { requiresAuth: true } },
  { path: '/flyers/saved', name: 'saved-flyers', component: SavedFlyers, meta: { requiresAuth: true } },
  { path: '/account', name: 'my-account', component: MyAccount, meta: { requiresAuth: true } },
  { path: '/account/profile/edit', name: 'update-profile', component: UpdateProfile, meta: { requiresAuth: true } },
  { path: '/users/:id', name: 'user-profile', component: UserProfile, meta: { public: true } },
  { path: '/flyers/:id', name: 'flyer-detail', component: FlyerDetail, meta: { public: true } },
  { path: '/flyers/:id/info', name: 'flyer-info', component: FlyerInfo, meta: { requiresAuth: true } },
  { path: '/hashtags/:hashtag', name: 'hashtag-flyers', component: HashtagFlyers, meta: { public: true } },
  { path: '/businesses/:businessId/reviews', name: 'business-reviews', component: BusinessReviews, meta: { public: true } },
  { path: '/account/change-password', name: 'change-password', component: ChangePassword, meta: { requiresAuth: true } },
  { path: '/boards', name: 'boards', component: Boards, meta: { requiresAuth: true } },
  { path: '/chats', name: 'chats', component: Chats, meta: { requiresAuth: true } },
  { path: '/about', name: 'about', component: About, meta: { public: true } },
  { path: '/privacy-policy', name: 'privacy-policy', component: PrivacyPolicy, meta: { public: true } },
  { path: '/terms-conditions', name: 'terms-conditions', component: TermsConditions, meta: { public: true } },
  { path: '/terms-and-conditions', redirect: '/terms-conditions', meta: { public: true } },
  { path: '/faqs', name: 'faqs', component: Faqs, meta: { requiresAuth: true } },
  { path: '/support', name: 'support', component: Support, meta: { public: true } },
  { path: '/settings', name: 'settings', component: Settings, meta: { requiresAuth: true } },
  { path: '/settings/timezone', name: 'timezone-settings', component: TimezoneSettings, meta: { requiresAuth: true } },
  { path: '/:pathMatch(.*)*', redirect: '/explore' }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0, left: 0 }
  }
})

router.beforeEach((to) => {
  const session = useSessionStore()

  if (!session.user) {
    session.loadUser()
  }

  if (to.meta.requiresAuth && !session.isLoggedIn) {
    return {
      path: '/login',
      query: { redirect: to.fullPath }
    }
  }

  if (to.meta.guestOnly && session.isLoggedIn) {
    return '/explore'
  }

  return true
})

export default router
